export class DataPoint<K, V> {
  constructor(
    public readonly name: K,
    public readonly value: V
  ) {}
}
